import React from 'react';
import styles from './Loader.module.scss';
import oiiaGif from '../../assets/oiia-oiiaoiia.gif';
import polishCowGif from '../../assets/polish-cow.gif';
import {useCurrentUser} from "../../contexts/CurrentUser";

/** @param {{ className?: string }} props */
export const Loader = ({ className }) => {
  const [currentUser] = useCurrentUser();
  const workspaceConfig = currentUser?.workspace?.config;
  const featureFlags = workspaceConfig?.featureflags;
  const isFunnyLoaderEnabled = featureFlags?.includes('funny_loader');
  const rootClassName = className ? `${styles.root} ${className}` : styles.root;

  if (!isFunnyLoaderEnabled) {
    return (
      <div className={rootClassName}>
        <div className={styles.container}>
          <div className={styles.circle} />
          <div className={styles.circle} />
          <div className={styles.circle} />
          <div className={styles.circle} />
          <div className={styles.circle} />
        </div>
      </div>
    );
  }

  const selectedGif = Math.random() < 0.5 ? oiiaGif : polishCowGif;

  return (
    <div className={rootClassName}>
      <div className={styles.container}>
        <img
          width={150}
          height={150}
          src={selectedGif}
          alt="Loading..."
        />
        <img
          width={150}
          height={150}
          src={selectedGif}
          alt="Loading..."
        />
        <img
          width={150}
          height={150}
          src={selectedGif}
          alt="Loading..."
        />
      </div>
    </div>
  );
};
